export default "__VITE_ASSET__59f53612__"